import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Divider from 'material-ui/Divider';

class AccessCode extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            code: ""
        };
    }

    codeChange = (event) => {
        this.setState({ lastname: event.target.value });
    }

  render() {

    return (
        <div className="container">
            <h2>Please enter the verification code from your email. </h2>
            <br />
            <TextField hintText="Verification Code" value={this.state.code} onChange={this.codeChange} fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}} />
            <br />
            <br />
            <RaisedButton label="Verify" primary={true} onClick={this.props.identify} fullWidth={true} style={{height:45}}  labelStyle={{fontSize: '26px'}}  />
            <br />
            <Divider />
            <br />
                <h5>If you didn't receive an email then please click the button below to resend it.</h5>
                <FlatButton label="Resend Verification Email" primary={true} onClick={this.props.resendEmail} fullWidth={true} />
        </div>
    );
  }

};

export default AccessCode;


// WEBPACK FOOTER //
// ./src/Components/AccessCode.js